export const apiEndPoints = Object.freeze({
    USER: {
        CREATE_USER: '/admin/users',
        DELETE_USER: (userId) => `/admin/users/${userId}`,
        UPDATE_USER: (userId) => `/admin/users/${userId}`
    },
    POST: {
        DELETE_POST: (postId, postType) => `/admin/posts/${postId}?type=${postType}`,
        UPDATE_POST: (postId) => `/admin/posts/${postId}`,
        CREATE_POST: '/admin/posts',
        UPLOAD_IMAGE: '/admin/images',
        COPY_IMAGE: '/admin/images/copy',
        DESTROY_IMAGE: '/admin/images/delete',
    },
    TAGS: {
        GET_TAGS: (typeParam) => `/admin/tags?type=${typeParam}`
    },
    AUTH: {
        LOGOUT_GET: '/admin/logout'
    }
});
